export default (elem) => {
  const members = elem.querySelectorAll('.team-block__member');
  const bios = elem.querySelectorAll('.team-block__member-bio');

  elem.addEventListener('click', (e) => {
    const member = e.target.closest('.team-block__member');
    const mobileButton = e.target.closest('.team-block__member-button--mobile');
    const desktopButton = e.target.closest('.team-block__member-button--desktop');

    if (mobileButton) {
      mobileButton.style.display = 'none';
      mobileButton.nextElementSibling.style.display = 'block';
    }

    if (desktopButton) {
      members.forEach(item => item.classList.remove('team-block__member--active'));
      bios.forEach(item => item.style.display = 'none');

      member.classList.add('team-block__member--active');
      const activeBio = elem.querySelector(`.team-block__bios .team-block__member-bio[data-bio-id="${member.dataset.memberId}"]`);
      activeBio.style.display = 'block';
    }
  })
}